var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('land-page-slider'),_c('section',{ref:'about',staticClass:"section"},[_c('land-page-about')],1),_c('section',{ref:'tutorial'},[_c('land-page-tutorial')],1),_c('section',{staticClass:"section"},[_c('land-page-partner')],1),_c('section',{ref:'contact'},[_c('land-page-contact')],1),_c('section',[_c('land-page-footer')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }